import { store } from '../store';
import type { RootState } from '../store';
import type { IUser } from '@/common/interfaces/user.interface';

/**
 * Method to determine if the user can access the design tool.
 *
 * @param _user - The user object.
 */
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const isUserCanAccessDesignTool = (_user: IUser) => true;

/**
 * @returns The version of the DT changes AB test for Mixpanel.
 */
export const getDtAbTestVersionForMixpanel = () => {
  const state: RootState = store.getState();
  const { user } = state.user;

  return isUserCanAccessDesignTool(user) ? 'Accessible' : 'Not Accessible';
};

/**
 * Method to determine if the user can pay later.
 * It's based on the user's account_id.
 */
export const canClientPayLater = () => {
  const state: RootState = store.getState();
  const { user } = state.user;

  return !!user.account_id;
};
